<template>
    <div>
        <vue-headful :title="$t('stud-clubs')" />
        <!-- Для модератора заявки на вступления и редактирования -->
        <!-- <div
            v-if="isModerator"
            :class="wMobile ? 'flex-wrap' : ''"
            class="flex justify-between"
        >

            <vs-button
             class="w-full"
             type="border"
             @click="$router.push({ name: 'stud-clubs-regRequests' })"
            >{{ $t("application_requests")}}</vs-button>


            <vs-button
             class="w-full"
             :class="wMobile ? '' : 'ml-2'"
               type="border"
               color="success"
                @click="
                    $router.push({
                        name: 'stud-clubs-regRequests',
                        query: { edit: true },
                    })
                "
            >
                {{ $t("application_requests_edit")}}
            </vs-button>
        </div> -->
        <!-- Поиск по имени клуба -->
        <div
            class="flex"
            :class="wMobile ? 'flex-col' : ''"
            :style="wMobile ? '' : 'align-items: flex-end'"
        >
            <vs-input
                :class="wMobile ? 'w-full mt-2' : 'flex-1'"
                icon-after="true"
                icon="search"
                v-model="searchClub"
                @change="getClubs"
                :label-placeholder="$t('search')"
            />
            <!-- Создать клуб -->
            <vx-tooltip :text="$t('create_studclub')">


            <vs-button
                @click="$router.push({ name: 'stud-clubs-create' })"
                class="px-6 ml-0 lg:ml-2"
                :class="wMobile ? 'mt-2' : ''"
                icon="add"
                size="middle"
            >
                <!-- {{ $t("create_studclub") }} -->
                </vs-button>
                 </vx-tooltip>
            <!-- Ппросмотр моих заявок -->
            <vx-tooltip :text="$t('my_application')" color="warning">
                <vs-button
                    @click="
                    $router.push({
                        name: 'stud-clubs-regRequests',
                        query: { my: true },
                    })
                "
                    class="px-6 ml-0 lg:ml-2"
                    :class="wMobile ? 'mt-2' : ''"
                    color="warning"
                    icon="assignment"
                    size="middle"
                ></vs-button>
            </vx-tooltip>

        </div>
        <!-- Список клубов -->
        <h6 class="mt-4">{{ clubs.length }} {{ $t("resultss") }}</h6>
        <div v-if="clubs.length > 0" class="vx-row mt-4">
            <div
                class="vx-col"
                :class="wMobile ? 'w-full' : 'w-1/2'"
                v-for="(item, key) in clubs"
                :key="key"
            >
                <list-card
                    :image="item.club_logo.path"
                    :title="item.name"
                    :subscibe="item.status"
                    :description="item.description"
                    :director="item.founder.student_profile"
                    :participants="item.student_club_members.slice(0, 5)"
                    :type="item.club_type.name"
                    :status="item.public_or_private"
                    @eventMore="goMain(item)"
                />
            </div>
        </div>
        <div v-else>
            <span class="pl-6">{{ $t("list_empty") }}</span>
        </div>
        <!-- Зугрузить еще -->
        <div class="flex justify-center mt-base">
            <vs-button
                v-show="more"
                id="button-load-more-posts"
                class="vs-con-loading__container"
                @click="getMoreClubs"
                >{{ $t("upload_more") }}</vs-button
            >
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ListCard from "./components/ListCard";
export default {
    components: {
        ListCard,
    },
    data() {
        return {
            clubs: [],
            allClubs: false,
            more: false,
            page: 1,
            searchClub: "",
        };
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
    },

    async created() {
        // Получение роли модератора
        this.getRoles();
        // Запрос список клубов
        await this.getClubs();
    },
    methods: {
        ...mapActions({
            getRoles: "studclubs/getRoles",
        }),
        // Список клубов
        async getClubs() {
            this.$vs.loading();
            this.clubs = [];
            await this.getStudentClubs();
            await this.getAllClubs();
            this.$vs.loading.close();
        },
        // Получение клбуов студента
        async getStudentClubs() {
            this.$vs.loading();
            const res = await this.$http(
                `student_clubs/my_student_clubs?student_club_name=${ this.searchClub }`
            );

            if (res.status === 200) {
                res.data.forEach((el) => {
                    el.status = true;
                    this.clubs.push(el);
                });
            }
            this.$vs.loading.close();
        },
        // Поучение всех клубов
        async getAllClubs() {
            this.$vs.loading();
            const res = await this.$http(
                `student_clubs/my_student_clubs/get_all_student_clubs/?page=${ this.page }&student_club_name=${ this.searchClub }`
            );
            if (res.status === 200) {
                res.data.results.forEach((el) => {
                    el.status = false;
                    this.clubs.push(el);
                });
                if (!res.data.next) {
                    this.more = false;
                } else {
                    this.more = true;
                }
            }
            this.$vs.loading.close();
        },
        // Метод для пагинации
        async getMoreClubs() {
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: "#button-load-more-posts",
                scale: 0.45,
            });

            this.page += 1;
            await this.getAllClubs();

            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },
        // Вернуться назад
        goMain(item) {
            this.$router.push({
                name: "stud-clubs-main",
                query: { uid: item.uid },
            });
        },
    },
};
</script>
